<template>
  <div>
    <div
      v-for="(pendency, index) in pendencies"
      :key="index"
    >
      <div class="data-table__body__row">
        <data-cell :size="10">
          <h4 class="text-color-tundora capitalize">
            {{ formatDate(pendency?.createdAt) }}
          </h4>
          <p
            v-if="pendency?.createdAt"
            class="text-color-amaranth"
          >
            às {{ formatHour(pendency?.createdAt) }}
          </p>
        </data-cell>

        <data-cell :size="10">
          <p class="text-color-amaranth">
            {{ pendency?.number_alvaro_order }}
          </p>
        </data-cell>

        <data-cell :size="15">
          <h4
            v-if="pendency?.patient_name"
            class="text-color-tundora capitalize overflow"
            :title="pendency?.patient_name"
          >
            {{ capitalize(pendency?.patient_name) }}
          </h4>
          <h4 v-else>
            -
          </h4>
        </data-cell>

        <data-cell :size="10">
          <p
            v-if="pendency?.exams && pendency?.exams.length > 0"
            class="text-color-amaranth capitalize overflow"
          >
            <span
              v-for="(exam, i) in pendency?.exams"
              :key="i"
            >
              {{ uppercase(exam.codigoExterno) }}<span v-if="i + 1 < pendency?.exams.length">, </span>
            </span>
            <md-tooltip>
              <span
                v-for="(exam, i) in pendency?.exams"
                :key="'tooltip-' + i"
              >
                {{ exam.codigoExterno }}<span v-if="i + 1 < pendency?.exams.length">, </span>
              </span>
            </md-tooltip>
          </p>
          <p
            v-else
            class="empty-exam"
          >
            -
          </p>
        </data-cell>

        <data-cell :size="15">
          <h4 class="text-color-tundora capitalize overflow">
            {{ pendency?.reason }}
            <md-tooltip>{{ pendency?.reason }}</md-tooltip>
          </h4>
        </data-cell>

        <data-cell :size="15">
          <div v-if="pendency?.concludedDate">
            <h4 class="text-color-tundora capitalize">
              {{ formatDate(pendency?.concludedDate) }}
            </h4>
            <p
              v-if="pendency?.createdAt"
              class="text-color-amaranth"
            >
              às {{ formatHour(pendency?.concludedDate) }}
            </p>
          </div>
          <div v-else>
            <span class="text-center"> - </span>
          </div>
        </data-cell>

        <data-cell
          :size="15"
          class="status"
          :class="'status-' + status[pendency?.status].color"
        >
          <p>{{ status[pendency?.status].message }}</p>
        </data-cell>

        <data-cell
          :size="10"
          :class="'action-' + status[pendency?.status].state"
        >
          <button
            class="pendencie-btn"
            :class="'btn-primary-' + status[pendency?.status].color"
            @click="$emit('openModal', pendency)"
          >
            <svg-loader
              class="icon"
              :src="'/static/images/' + status[pendency?.status].icon"
            />
            <md-tooltip md-direction="bottom">
              {{ status[pendency?.status].message }}
            </md-tooltip>
          </button>

          <button
            v-if="pendency.transmissionFiles && pendency.transmissionFiles.length"
            class="pendencie-btn btn-primary"
            @click="$emit('openPendencyImages', pendency)"
          >
            <svg-loader
              class="icon"
              :src="'/static/images/icon-image.svg'"
            />
            <md-tooltip md-direction="bottom">
              Imagens da pendência
            </md-tooltip>
          </button>
        </data-cell>
      </div>
    </div>
  </div>
</template>

<script>
import DataCell from '@/components/common/dataTable/DataCell'
import { startCase } from 'lodash'

export default {
  name: 'PendencyRow',
  components: {
    'data-cell': DataCell
  },
  props: {
    pendencies: {
      type: Array,
      required: true
    },
    status: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatDate(date) {
      return date ? new Date(date).toLocaleDateString('pt-BR') : ''
    },
    formatHour(date) {
      return date ? new Date(date).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) : ''
    },
    capitalize(value) {
      return startCase(value.toLowerCase())
    },
    uppercase(value) {
      return value?.toUpperCase() ?? '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.pendencie-btn {
  height: 40px;
  border-radius: 8px;
  max-width: 40px;
  padding: 8px !important;
}
</style>
